import { changesDigitalData, pushDigitalData } from '@/utils/digitalData';

const usePage = () => {
  /**
   * @param {Object} page
   * @param {string} page.type
   * @param {string} page.category
   * @param {string} [page.url]
   * @param {string} [page.path]
   * @param {string} [page.queryString]
   * @param {string} [page.hash]
   * @param {string} [page.title]
   * @param {Array} [page.breadcrumb]
   */
  const viewPage = (page) => {
    if (!page.category) throw new Error('[DigitalData:viewPage] поле page.category обязательно для заполнения');
    if (!page.type) throw new Error('[DigitalData:viewPage] поле page.type обязательно для заполнения');
    const dataPage = window?.digitalData?.page || {};
    const resultDataPage = {
      ...dataPage,
      url: page.url || window.location.href,
      path: page.path || window.location.pathname,
      queryString: page.queryString || window.location.search,
      hash: page.hash || window.location.hash,
      title: page.title || document.title,
      category: page.category,
      type: page.type,
    };
    if (page.breadcrumb) {
      resultDataPage.breadcrumb = page.breadcrumb;
    }
    changesDigitalData(['page', resultDataPage, 'book24']);
    pushDigitalData({ name: 'Viewed Page' });
  };

  return { viewPage };
};

export default usePage;
